import React, { Fragment } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import history from "./history";

import PageNotFound from "./containers/pages/404";
import Login from "./containers/pages/Login";
import Verification from "./containers/pages/Verification";
import Dashboard from "./containers/pages/Dashboard";
import ForgotPassword from "./containers/pages/ForgotPassword";
import Register from "./containers/pages/Register";
import FormComponent from "./containers/pages/Test/FormComponent";
import ResendVerification from "./containers/pages/ResendVerification";
import ResetPassword from "./containers/pages/ResetPassword";
import TestingPage from "./containers/pages/Test";
import LengkapiProfil from "./containers/pages/LengkapiProfil";
import Profil from "./containers/pages/Profil";
import RiwayatTransaksi from "./containers/pages/RiwayatTransaksi";
import Notifikasi from "./containers/pages/Notifikasi";
import NotifikasiDetil from "./containers/pages/NotifikasiDetil";
import PengajuanPinjaman from "./containers/pages/PengajuanPinjaman";
import PengajuanPinjamanDetil from "./containers/pages/PengajuanPinjamanDetil";
import PengajuanPinjamanTambah from "./containers/pages/PengajuanPinjamanTambah";
import StatusPinjamanDetil from "./containers/pages/StatusPinjamanDetil";
import DraftPinjaman from "./containers/pages/DraftPinjaman";
import DraftPinjamanDetil from "./containers/pages/DraftPinjamanDetil";
import UbahPassword from "./containers/pages/UbahPassword";
import PinjamanAktif from "./containers/pages/PinjamanAktif";
import RiwayatPinjaman from "./containers/pages/RiwayatPinjaman";

const PageNotFoundRoute = (props) => <Redirect to="/404"></Redirect>;

const Router = () => (
  <Switch>
    <Route path="/" component={wrappedRoutes} history={history} />
  </Switch>
);

const wrappedRoutes = () => (
  <Switch>
    <Route exact path="/reset-password/:email/:id" component={ResetPassword} />
    <Route exact path="/forgot-password" component={ForgotPassword} />
    <Route exact path="/resend-verification" component={ResendVerification} />
    <Route exact path="/register" component={Register} />
    <Route exact path="/login" component={Login} />
    <Route
      exact
      path="/verification/:id/:verificationCode"
      component={Verification}
    />
    <Route path="/404" component={PageNotFound} />
    <Route path="/testkomponen" component={TestingRoute} />
    <Route path="/" component={HomeRoute} />
  </Switch>
);

const TestingRoute = () => (
  <Switch>
    <Route exact path="/testkomponen" component={TestingPage} />
    <Route exact path="/testkomponen/form" component={FormComponent} />
  </Switch>
);

const NotifikasiRoute = () => (
  <Switch>
    <Route exact path="/notifikasi" component={Notifikasi} />
    <Route exact path="/notifikasi/detil/:id" component={NotifikasiDetil} />
    <Route exact component={PageNotFoundRoute} />
  </Switch>
);

const PengajuanPinjamanRoute = () => (
  <Switch>
    <Route exact path="/pengajuan-pinjaman" component={PengajuanPinjaman} />
    <Route
      exact
      path="/pengajuan-pinjaman/tambah"
      component={PengajuanPinjamanTambah}
    />
    <Route
      exact
      path="/pengajuan-pinjaman/detil/:loanCode"
      component={PengajuanPinjamanDetil}
    />
    <Route exact component={PageNotFoundRoute} />
  </Switch>
);

// const StatusPinjamanRoute = () => (
// 	<Switch>
// 		<Route exact path='/status-pinjaman' component={StatusPinjaman} />
// 		<Route exact path='/status-pinjaman/detil/:loanCode' component={StatusPinjamanDetil} />
// 		<Route exact component={PageNotFoundRoute}/>
// 	</Switch>
// )

const PinjamanAktifRoute = () => (
  <Switch>
    <Route exact path="/pinjaman-aktif" component={PinjamanAktif} />
    <Route
      exact
      path="/pinjaman-aktif/detil/:loanCode"
      component={StatusPinjamanDetil}
    />
    <Route exact component={PageNotFoundRoute} />
  </Switch>
);

const RiwayatPinjamanRoute = () => (
  <Switch>
    <Route exact path="/riwayat-pinjaman" component={RiwayatPinjaman} />
    <Route
      exact
      path="/riwayat-pinjaman/detil/:loanCode"
      component={StatusPinjamanDetil}
    />
    <Route exact component={PageNotFoundRoute} />
  </Switch>
);

const DraftPinjamanRoute = () => (
  <Switch>
    <Route exact path="/draf-pinjaman" component={DraftPinjaman} />
    <Route exact path="/draf-pinjaman/add/" component={DraftPinjamanDetil} />
    <Route
      exact
      path="/draf-pinjaman/edit/:loanCode"
      component={DraftPinjamanDetil}
    />
    <Route exact component={PageNotFoundRoute} />
  </Switch>
);

const HomeRoute = (props) => (
  <Fragment>
    <Switch>
      <Route exact path="/" component={Dashboard} />
      <Route exact path="/dashboard" component={Dashboard} />
      <Route exact path="/lengkapi-profil" component={LengkapiProfil} />
      <Route exact path="/profil" component={Profil} />
      <Route exact path="/riwayat-transaksi" component={RiwayatTransaksi} />
      <Route exact path="/ubah-password" component={UbahPassword} />
      <Route path="/pengajuan-pinjaman" component={PengajuanPinjamanRoute} />
      <Route path="/notifikasi" component={NotifikasiRoute} />
      <Route path="/riwayat-pinjaman" component={RiwayatPinjamanRoute} />
      <Route path="/pinjaman-aktif" component={PinjamanAktifRoute} />
      <Route path="/draf-pinjaman" component={DraftPinjamanRoute} />
      <Route exact component={PageNotFoundRoute} />
    </Switch>
  </Fragment>
);

export default Router;
